import { render, staticRenderFns } from "./dealerBGI.vue?vue&type=template&id=5c4879ca&"
import script from "./dealerBGI.vue?vue&type=script&lang=js&"
export * from "./dealerBGI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports